import { apiService } from './apiService';
import { StudentEvent, CreateEventInput, UpdateEventInput } from '../types/calendar';

export async function getEvents(
  start?: string,
  end?: string,
  eventType?: string,
): Promise<StudentEvent[]> {
  const params = new URLSearchParams();
  if (start) params.set('start', start);
  if (end) params.set('end', end);
  if (eventType) params.set('event_type', eventType);
  const qs = params.toString();
  const url = `/calendar/events${qs ? `?${qs}` : ''}`;
  const response = await apiService.get<StudentEvent[]>(url);
  return response.data;
}

export async function getUpcomingEvents(limit = 7): Promise<StudentEvent[]> {
  const response = await apiService.get<StudentEvent[]>(`/calendar/upcoming?limit=${limit}`);
  return response.data;
}

export async function createEvent(input: CreateEventInput): Promise<StudentEvent> {
  const response = await apiService.post<StudentEvent>('/calendar/events', input);
  return response.data;
}

export async function updateEvent(id: string, input: UpdateEventInput): Promise<StudentEvent> {
  const response = await apiService.put<StudentEvent>(`/calendar/events/${id}`, input);
  return response.data;
}

export async function deleteEvent(id: string): Promise<void> {
  await apiService.delete(`/calendar/events/${id}`);
}

export const calendarService = {
  getEvents,
  getUpcomingEvents,
  createEvent,
  updateEvent,
  deleteEvent,
};
